import React, { useState, useEffect, useContext } from "react"
import { useTranslation } from "react-i18next"
import MobileHeaderPopup from './MobileHeaderPopup'
import BasicLink from "../../basics/Link"
// import { router } from "../../../utility/router"
import { getHeaderTheme } from "./headerUtility"
import { Link } from "gatsby"
import { router } from "../../../utility/router"
import { PageContext } from "../Page"

import FabrickLogo from '../../../assets/logos/fabrick-logo.svg'
import HamburgerIcon from '../../../assets/icons/hamburger-header.svg'
import CrossIcon from '../../../assets/icons/cross-header.svg'
import Arrow from '../../../assets/icons/right-arrow-header-mobile.svg'
import SearchIcon from '../../../assets/icons/search.svg'
import SearchNegativeIcon from '../../../assets/icons/search-negative.svg'
import cx from "classnames"

const MobileHeader = ({ type = 'full', theme, isTransparent, isTopOfThePage, topPosition, shadow, logoUrl }) => {
  const [isOpen, setIsOpen] = useState(false)
  // Indica il menu che è aperto in questo momento
  const [currentMenu, setCurrentMenu] = useState('')
  const currentTheme = getHeaderTheme(theme, isTransparent, isTopOfThePage, isOpen)
  const showBackButton = currentMenu !== '' && isOpen
  const [t] = useTranslation('layout')
  const context = useContext(PageContext)
  const fixed = context.layout.headerFixed

  useEffect(() => {
    toggleBodyScrolling(true)
    setIsOpen(false)
  }, [])

  function toggleOpen() {
    // if (!isOpen) {
    //   // setCurrentMenu('')
    // }
    toggleBodyScrolling(isOpen)
    setIsOpen(!isOpen)
  }

  function toggleBodyScrolling(allow) {
    let html = document.querySelector("html")
    html.style.overflowY = allow ? "" : 'hidden'
  }

  function closeMenu() {
    setIsOpen(false)
    toggleBodyScrolling(true)
    setCurrentMenu('')
  }

  function changeCurrentMenu(newMenu) {
    setCurrentMenu(newMenu)
  }

  return <div style={{ transformStyle: "preserve-3d" }} className={cx(`header header-mobile:hidden ${topPosition} ${shadow} ${currentTheme.bgColor} ${currentTheme.transitions} w-full max-w-[1920px] h-header flex items-center justify-between px-container-mobile md:px-container-desktop z-[100]`, { "sticky": !fixed, "fixed": fixed })}>
    <BasicLink to={logoUrl}>
      <FabrickLogo className={`w-[100px] h-[24px] min-w-[100px] ${currentTheme.transitions} ${currentTheme.vectorFill} ${showBackButton ? 'opacity-0' : ''}`} />
    </BasicLink>
    <button onClick={() => changeCurrentMenu('')} className={`${showBackButton ? '' : 'opacity-0 pointer-events-none'} flex items-center absolute left-container-mobile transition-all`}>
      <Arrow className="inline-block stroke-blue-10 mr-0.5 rotate-180" /><div className="inline-block body text-blue-10 font-bold">{t('header.goBack')}</div>
    </button>

    {type === 'full' && <>
      <div className="select-none relative">
        <Link to={router('search', context.folder)} className=" absolute py-3 pl-3 pr-1 top-[-24px] right-[calc(100%+16px)]">
          {currentTheme.theme === "dark" ? <SearchNegativeIcon /> : <SearchIcon />}
        </Link>
        <HamburgerIcon className={`w-[24px] h-[24px] ${currentTheme.vectorStroke} ${isOpen ? 'opacity-0' : ''} ${currentTheme.transitions}`} />
        <CrossIcon className={`w-[24px] h-[24px] absolute top-0 left-0 ${currentTheme.vectorStroke} ${isOpen ? '' : 'opacity-0'} ${currentTheme.transitions}`} />
        <button onClick={() => toggleOpen()} className="absolute w-[64px] h-[64px] top-[-20px] left-[-20px]" />
      </div>

      <MobileHeaderPopup isOpen={isOpen} currentMenu={currentMenu} changeCurrentMenu={changeCurrentMenu} closeMenuFunction={closeMenu} />
    </>}
  </div>
}

export default MobileHeader